import { createSlice } from '@reduxjs/toolkit';

const dataSlice = createSlice({
    name: 'mobileMenu/data',
    initialState: {
        mobileMenuState: false,
    },
    reducers: {
        setMobileMenuState: (state, action) => {
            state.mobileMenuState = action.payload;
        },
    },
    extraReducers: {
    }
})

export const { setMobileMenuState } = dataSlice.actions

export default dataSlice.reducer
